import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { StatusCard, TextToolTip } from 'components';
import { ScheduleDetails } from 'fragments';
import { EmptyStateDashboard } from './emptyStateDashboard';
import { DashboardWidgetShell, DashboardWidgetSkeleton } from './widgets';
import { DashboardTabs } from './dashboardTabs';
import { UpcomingApptTab as TABS, UpcomingApptTabs } from './constants';
import { FindLoad, Images, SaveParams, useSecondaryModal } from 'utils';
import { dashboardActions } from 'store';
import { Svg } from 'assets';

const ACTION_TYPE = 'GET_DASHBOARD_UPCOMING_APPTS';

export const UpcomingAppointments = ({ item, handleDeleteWidget }) => {
    const { upcomingAppointments } = useSelector((state) => ({
        upcomingAppointments: state.dashboard.upcomingAppointments,
    }));
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const { openSecondary } = useSecondaryModal();
    const loader = FindLoad(ACTION_TYPE);
    const info = location?.state;
    const [activeTab, setActiveTab] = useState(TABS.UPCOMING);
    const currentAppts = activeTab === TABS.UPCOMING ? upcomingAppointments?.upcomingAppt?.appts : upcomingAppointments?.overdueAppt?.appts;

    useEffect(() => {
        if (item?.apiPath) {
            dispatch(dashboardActions.getWidgetsData(ACTION_TYPE, item?.apiPath));
        }
    }, [item?.apiPath]);

    const resetChart = () => {
        const params = {
            ...info,
        };
        SaveParams(navigate, params);
    };

    const formatDate = (item) => {
        const start = moment.utc(item?.startTime);
        const end = moment.utc(item?.endTime);

        return `${start.format('dddd')}, ${start.format('MM/DD/YYYY')}, ${start.format('h:mma')}-${end.format('h:mma')}`;
    };

    const getDaysAgo = (appt) => {
        const start = moment.utc(appt?.startTime).startOf('day');
        const today = moment().startOf('day');
        const diff = today.diff(start, 'days');
        return diff;
    };

    if (loader?.length) {
        return <DashboardWidgetSkeleton />;
    }

    return (
        <DashboardWidgetShell
            iconId={1}
            onClose={(e) => handleDeleteWidget(e, item, resetChart)}
        >
            <div className="dashboard-tabbed-body">
                <DashboardTabs
                    activeKey={activeTab}
                    onChange={setActiveTab}
                    tabs={UpcomingApptTabs.map((tab) => ({
                        ...tab,
                        count:
                            tab.key === TABS.UPCOMING
                                ? upcomingAppointments?.upcomingAppt?.count
                                : upcomingAppointments?.overdueAppt?.count,
                    }))}
                />

                <div className="upcoming-appt-card-body">
                    {currentAppts?.length ? (
                        currentAppts.map((appt) => (
                            <div
                                key={appt?.id}
                                className="upcoming-appointments-card-wrapper"
                                onClick={() => openSecondary(<ScheduleDetails currentId={appt?.id} />)}
                                style={appt?.authBillable === false ? { background: 'repeating-linear-gradient(135deg, #E4E7EC 0px, #E4E7EC 1px, #FEFCE8 1px, #FEFCE8 14px)' } : {}}
                            >
                                <div className="upcoming-appointments-card-header">
                                    <p className="upcoming-appointments-card-header-title">{appt?.displayId}</p>

                                    <div className="upcoming-appointments-card-header-status-arrow">
                                        <StatusCard status={activeTab === TABS.OVERDUE ? 'OVERDUE' : 'PENDING'} />
                                        <Svg.ArrowRight2Svg />
                                    </div>
                                </div>

                                <div className="upcoming-appointments-card-body">
                                    <div className="upcoming-appointments-card-item">
                                        <div className="upcoming-appointments-card-item-svg">
                                            <img
                                                src={Images.calendar}
                                                alt="calendar"
                                            />
                                        </div>

                                        <TextToolTip
                                            text={formatDate(appt)}
                                            content={formatDate(appt)}
                                            classNameText="upcoming-appointments-card-item-text"
                                        />
                                    </div>

                                    {appt?.clientName && (
                                        <div className="upcoming-appointments-card-item">
                                            <div className="upcoming-appointments-card-item-svg">
                                                <img
                                                    src={Images.client}
                                                    alt="client"
                                                />
                                            </div>

                                            <TextToolTip
                                                text={appt?.clientName}
                                                content={appt?.clientName}
                                                classNameText="upcoming-appointments-card-item-text"
                                            />
                                        </div>
                                    )}

                                    {activeTab === TABS.OVERDUE && (
                                        <div className="upcoming-appointments-card-overdue-info">
                                            <Svg.AlertCircleSvg />
                                            <p>Scheduled {getDaysAgo(appt)} days ago</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))
                    ) : (
                        <EmptyStateDashboard
                            iconId={1}
                            title={activeTab === TABS.UPCOMING ? 'No appointments scheduled' : 'No overdue appointments!'}
                            description={
                                activeTab === TABS.UPCOMING
                                    ? 'Your upcoming appointments will appear here'
                                    : 'All your appointments are up to date'
                            }
                        />
                    )}
                </div>
            </div>
        </DashboardWidgetShell>
    );
};
